export default {
    PLANS: '/plans',
    CSVCALLINGRATES: 'csv-calling-rates',
};
